import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import background from "../assets/sideline/sideline-background.webp";
import wearTheColors from "../assets/sideline/wear-the-colors.png";
import sidelineSociety from "../assets/sideline/sideline-society.png";
import together from "../assets/sideline/together-on-the-journey.png";
import samePassion from "../assets/sideline/same-passion-different-position.png";
import "./SidelineBanner.css";

// The lettering is original brand artwork, separated from the clean photo so
// responsive layouts preserve its exact shapes instead of approximating a font.
export const SidelineBanner = () => (
  <section className="sideline-banner" lang="en" aria-labelledby="sideline-banner-heading" data-testid="public-supporter-banner">
    <div className="sideline-scene">
      <img src={background} width="2000" height="669" className="sideline-photo" loading="lazy" alt="Sideline Society supporter watching football, wearing the original branded black cap" data-testid="sideline-background" />
      <div className="sideline-copy">
        <h2 id="sideline-banner-heading" className="sideline-headline" data-testid="sideline-headline">
          <span className="sr-only">WEAR THE COLORS</span>
          <img src={wearTheColors} width="430" height="300" alt="" aria-hidden="true" data-testid="sideline-headline-artwork" />
        </h2>
        <p className="sideline-brand" data-testid="sideline-brand">
          <span className="sr-only">SIDELINE SOCIETY</span>
          <img src={sidelineSociety} width="365" height="117" alt="" aria-hidden="true" data-testid="sideline-brand-artwork" />
        </p>
        <p className="sideline-journey" data-testid="sideline-journey">
          <span className="sr-only">TOGETHER ON THE JOURNEY</span>
          <img src={together} width="470" height="39" alt="" aria-hidden="true" data-testid="sideline-journey-artwork" />
        </p>
        <p className="sideline-passion" data-testid="sideline-passion">
          <span className="sr-only">SAME PASSION DIFFERENT POSITION</span>
          <img src={samePassion} width="290" height="151" alt="" aria-hidden="true" data-testid="sideline-passion-artwork" />
        </p>
        <Link to="/shop?tab=merchandise" lang="el" className="public-button public-button-outline sideline-shop" data-testid="public-supporter-shop">
          ΤΟ ΚΑΤΑΣΤΗΜΑ ΜΑΣ <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>
    </div>
  </section>
);